import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadCallDetailsStore from 'stores/files/FileUploadCallDetailsStore';
import CallSyncCRMRecordDialog from 'components/pure/call-card/sync-crm/CallSyncCRMRecordDialog';
import CallSyncCRMDialogContainer from 'components/stateful/call-card/CallSyncCRMDialogContainer';
import FileUploadSharingStore from 'stores/sharing/FileUploadSharingStore';
import {Call} from '@store/call-card/Call';
import CallSharingDialogContainer from 'components/pure/sharing/CallSharingDialogContainer';
import CallDeleteStore from 'stores/files/CallDeleteStore';
import CallDeleteDialog from 'components/calls/components/CallDeleteDialog';
import FileUploadCallDetailsActions from 'actions/files/FileUploadCallDetailsActions';
import CallCardDetailsDialogContainer from 'components/pure/call-card/CallCardDetailsDialogContainer';

interface CallActionDialogsProps {
  call: Call;
}

@connectToStores
class CallActionDialogs extends React.PureComponent<
  CallActionDialogsProps & ReturnType<typeof CallActionDialogs.getPropsFromStores>
> {
  static getStores() {
    return [FileUploadCallDetailsStore, FileUploadSharingStore, CallDeleteStore];
  }

  static getPropsFromStores(props: CallActionDialogsProps) {
    const detailsState = FileUploadCallDetailsStore.getState();
    const shouldShowCallSyncCRM =
      detailsState.get('showCallSyncCRMForFileUpload') === props.call.id;
    const shouldShowCallCRMRecord =
      detailsState.get('showCallSyncCRMRecordDialog') === props.call.id;
    const shouldShowCallDeleteDialog = detailsState.get('callDeleteDialogFileId') === props.call.id;
    const showSharingDialog = FileUploadSharingStore.getState().showSharingDialog;
    const {isConfirmed, isDeleting, isDeleteError} = CallDeleteStore.getState();
    const shouldShowCallDetails =
      FileUploadCallDetailsStore.getState().showCallDetailsForFileUpload === props.call.id;
    return {
      shouldShowCallCRMRecord,
      shouldShowCallSyncCRM,
      shouldShowCallDeleteDialog,
      shouldShowCallDetails,
      showSharingDialog,
      isConfirmed,
      isDeleting,
      isDeleteError,
    };
  }

  render() {
    const {
      call,
      shouldShowCallDeleteDialog,
      shouldShowCallSyncCRM,
      shouldShowCallDetails,
      isDeleteError,
      showSharingDialog,
      isConfirmed,
      shouldShowCallCRMRecord,
      isDeleting,
    } = this.props;

    return (
      <>
        {showSharingDialog && (
          <CallSharingDialogContainer caller={call.caller} fileUploadId={call.id} />
        )}
        <CallSyncCRMDialogContainer open={shouldShowCallSyncCRM} fileUploadId={call.id} />
        <CallSyncCRMRecordDialog
          open={shouldShowCallCRMRecord}
          crmLink={call.crmLink}
          fileUploadId={call.id}
        />
        {shouldShowCallDeleteDialog && (
          <CallDeleteDialog
            callId={call.id}
            isConfirmed={isConfirmed}
            isDeleting={isDeleting}
            isDeleteError={isDeleteError}
            onRequestClose={FileUploadCallDetailsActions.hideCallDeleteDialog}
          />
        )}
        {shouldShowCallDetails && (
          <CallCardDetailsDialogContainer
            newCallCard
            useDialog
            call={call}
            onTouchTapCloseButton={() => FileUploadCallDetailsActions.hideCallDetails(call.id)}
            fileUploadId={call.id}
            template={call.template}
            caller={call.caller}
          />
        )}
      </>
    );
  }
}

export default CallActionDialogs as unknown as React.FC<CallActionDialogsProps>;
